/* =====================================================================
   SPORTS REALM — promo bar countdown
   ---------------------------------------------------------------------
   Writes hours, minutes and seconds into their own tiles so each digit pair
   can be styled and sized independently in the bar.

   The deadline is stored per session rather than recomputed on every load: the
   live theme's original version restarted its 12-hour clock on every page view,
   so the same "expires in" jumped back up as the shopper moved around the site.

   Nothing here asserts a price or a discount — it only renders a clock for the
   merchant-entered strings in the section. When the deadline passes the tiles
   read 00 and the interval stops; the bar keeps its height either way, so the
   page never shifts underneath the shopper.
   ===================================================================== */
(function () {
  'use strict';

  var KEY = 'srPromoDeadline';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function start(root) {
    if (!root || root.dataset.srPromoReady === 'true') return;

    var hh = root.querySelector('[data-sr-hh]');
    var mm = root.querySelector('[data-sr-mm]');
    var ss = root.querySelector('[data-sr-ss]');
    if (!hh || !mm || !ss) return;

    var hours = parseFloat(root.getAttribute('data-hours'));
    if (!hours || hours <= 0) hours = 12;
    var windowMs = hours * 60 * 60 * 1000;

    // sessionStorage throws in some privacy modes; a missing store just means
    // the countdown restarts, which is the old behaviour rather than an error.
    var deadline = 0;
    try {
      deadline = parseInt(window.sessionStorage.getItem(KEY), 10) || 0;
    } catch (e) {
      deadline = 0;
    }

    var now = Date.now();
    // Re-arm when absent, already past, or further out than the configured
    // window (which happens if the merchant shortens it mid-session).
    if (!deadline || deadline <= now || deadline - now > windowMs) {
      deadline = now + windowMs;
      try {
        window.sessionStorage.setItem(KEY, String(deadline));
      } catch (e) {
        /* not fatal — the clock still runs for this page view */
      }
    }

    var timer = null;

    function tick() {
      var left = Math.max(0, deadline - Date.now());
      var total = Math.floor(left / 1000);
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;

      // Only touch the DOM when a value actually changes: hours and minutes
      // then stay untouched for most of the 1s ticks.
      var hText = pad(h);
      var mText = pad(m);
      var sText = pad(s);
      if (hh.textContent !== hText) hh.textContent = hText;
      if (mm.textContent !== mText) mm.textContent = mText;
      if (ss.textContent !== sText) ss.textContent = sText;

      root.setAttribute('datetime', 'PT' + h + 'H' + m + 'M' + s + 'S');

      if (left <= 0 && timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    tick();
    timer = setInterval(tick, 1000);
    root.dataset.srPromoReady = 'true';
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sr-promo-clock]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
